export function addViewAllNewsButton(url, label) {
	const tabButtonsContainer = document.getElementById("actionsMenu");

	// Create a custom node for dynamically added button
	const tabButtonsNode = document.createElement("div");
	tabButtonsNode.setAttribute("id", "tabButtons");
	tabButtonsNode.classList.add("tab-buttons");

	const link = createLink(url, label);
	tabButtonsNode.appendChild(link);
	tabButtonsContainer.appendChild(tabButtonsNode);
}

function createLink(url, label) {
	const link = document.createElement("a");
	link.classList.add("btn", "btn--primary", "btn--news");
	link.setAttribute("href", url);
	const content = document.createElement("span");
	content.innerText = label;
	link.appendChild(content);
	return link;
}
